import React, {Component} from 'react'
import { Switch, Checkbox, Button, Popconfirm, message } from 'antd'
import {removeItemFromBox} from "../../../services/api/apiNextBox"

class TableHeadBoxItems extends Component {
    state = {
        loading: false
    }

    _handleChangeChecked = (e) => {
        const {onCheckAll} = this.props
        const checkedFba = e.target.checked

        if (typeof onCheckAll === 'function') {
            onCheckAll(checkedFba)
        }
    }

    hanldeRemoveListBoxs = async () => {
        this.setState({
            loading: true
        })
        try {
            const {arrSelected, onRefresh, onCheckAll} = this.props
            const dataFba = []
            for (const itemFba of arrSelected) {
                dataFba.push(await this.hanldeRemoveBoxItem(itemFba))
            }

            if(Array.isArray(dataFba) && !!dataFba.length && dataFba.every(iFba => !!iFba && iFba.success)){
                message.success('Xóa item trong thùng thành công!')
                onCheckAll(false)
                onRefresh()
            }else{
                const itemErrFba = dataFba.filter(iFba => !!iFba && !iFba.success)
                const firstErrFba = (itemErrFba && itemErrFba[0]) || {}

                message.error(firstErrFba.message || 'Xóa item trong thùng thất bại!')
                onCheckAll(false)
                onRefresh()
            }
        } catch (error) {
            window.alert(error.message)
        }finally{
            this.setState({
                loading: false
            })
        }
    }

    hanldeRemoveBoxItem = async (itemFba = {}) => {
        const {barcode} = Object.assign({}, itemFba)
        const {_id: boxIdFba} = this.props.box

        try {
            const {success, message: messFba} = await removeItemFromBox(boxIdFba, barcode)

            if (!success) return {
                success: false,
                message: messFba
            }

            return {
                success: true,
            }

        } catch (err) {
            return {
                success: false,
                message: err.message
            }
        }
    }

    render() {
        const { isAdmin, showDelete, handleCheckDelete, selectAll, arrSelected } = this.props
        const { loading } = this.state
        const messNotiFba = (!!arrSelected.length && arrSelected.map(iFba => `#${iFba.barcode}`).join(', ') || '')
        return (
            <thead className="TableHeadBoxItems">
                <tr>
                    {showDelete &&
                        <td>
                            <Checkbox
                                checked={selectAll}
                                onChange={this._handleChangeChecked}
                                disabled={loading}
                            />
                            {!!arrSelected.length &&
                            <Popconfirm
                                title={`Bạn có chắc chắn muốn xóa item ${messNotiFba} khỏi thùng`}
                                onConfirm={this.hanldeRemoveListBoxs}
                                placement="topRight"
                                okText="Yes"
                                cancelText="No"
                                overlayClassName='confirmRemoveBox'
                            >
                                <Button className='ml-2' type="danger" size='small' loading={loading} disabled={loading}>
                                    Xóa {`(${arrSelected.length} ${arrSelected.length > 1 ? 'items' : 'item'})`}
                                </Button>
                            </Popconfirm>
                            }
                        </td>
                    }
                    <th>#</th>
                    <th>ID
                        {isAdmin &&
                            <Switch
                                title='Tắt/Bật xóa item thùng'
                                onChange={handleCheckDelete}
                                className='ml-2'
                                value={showDelete}
                                checkedChildren="Xóa"
                                unCheckedChildren="Xóa"
                            />
                        }
                    </th>
                    <th>Loại sản phẩm</th>
                    <th>Size</th>
                    <th>Location</th>
                    <th>Tracking</th>
                    <th>Thời gian đóng gói</th>
                    <th>Shipment Status</th>
                </tr>
            </thead>
        )
    }
}

export default TableHeadBoxItems
